import React from 'react'

const UserAgreements: React.FC = () => {
    return (
        <div>
            <div className="prose prose-sm max-w-none px-10 pb-10 pt-10">

              <div className="mb-6">
                <div className="text-3xl font-bold mb-4">User Agreement</div>

                <div className="text-2xl font-semibold mt-6 mb-2">A. Parties &amp; Purpose</div>
                <p>This User Agreement (“Agreement”) is between you (“User”) and MokshSoft LLC (“MokshSoft”). It governs your use of the AdeptEPR.AI application developed in partnership with Adept Group LLC (“Adept Group”).</p>

                <div className="text-2xl font-semibold mt-6 mb-2">B. Grant of Rights</div>
                <p>MokshSoft hereby grants you a limited, revocable, non-exclusive, non-transferable right to use the Application solely for internal evaluation and feedback during the beta period.</p>

                <div className="text-2xl font-semibold mt-6 mb-2">C. User Obligations</div>
                <ol className="list-decimal list-inside space-y-1">
                  <li><strong>Beta Feedback.</strong> You agree to provide timely feedback, bug reports, and usage data to help improve the Application.</li>
                  <li><strong>Confidentiality.</strong> You will not disclose any non-public features, performance metrics, or internal processes of the Application without prior written consent.</li>
                </ol>

                <div className="text-2xl font-semibold mt-6 mb-2">D. Privacy &amp; Data</div>
                <p>We respect your privacy and are committed to protecting your personal data. By using the Application you agree to the following:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li><strong>Data Collected.</strong> We collect only the information you provide directly (e.g., account registration details, usage feedback, and any content you submit to the tool).</li>
                  <li><strong>Use of Data.</strong> We use your data to operate and improve the Application, deliver updates, respond to your feedback, and for security and analytics purposes.</li>
                  <li><strong>Data Sharing.</strong> We do not sell your personal information. We may share aggregated or de-identified data with partners, including Adept Group LLC, strictly for product improvement and research.</li>
                  <li><strong>Security.</strong> We implement reasonable administrative, technical, and physical safeguards to protect your information from unauthorized access or disclosure.</li>
                  <li><strong>Retention.</strong> We retain your data only as long as necessary to provide the beta service and to comply with legal obligations.</li>
                  <li><strong>Your Rights.</strong> You may request access to, correction of, or deletion of your personal data at any time by contacting privacy@mokshsoft.com.</li>
                </ul>

                <div className="text-2xl font-semibold mt-6 mb-2">E. Support &amp; Updates</div>
                <p>MokshSoft may provide updates, patches, or new releases at its discretion. There is no obligation to provide support or maintenance beyond what is agreed separately.</p>

                <div className="text-2xl font-semibold mt-6 mb-2">F. Warranties &amp; Disclaimers</div>
                <ol className="list-decimal list-inside space-y-1">
                  <li><strong>As-Is.</strong> THE APPLICATION IS PROVIDED “AS-IS” AND “AS AVAILABLE,” WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND.</li>
                  <li><strong>Disclaimer.</strong> MOKSHSOFT DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</li>
                </ol>

                <div className="text-2xl font-semibold mt-6 mb-2">G. Limitation of Liability</div>
                <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, MOKSHSOFT SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF YOUR USE OF THE APPLICATION, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</p>

                <div className="text-2xl font-semibold mt-6 mb-2">H. Indemnification</div>
                <p>You agree to defend, indemnify, and hold harmless MokshSoft, Adept Group, and their respective officers, directors, employees, and agents from any and all claims, liabilities, damages, losses, or expenses (including attorney’s fees) arising out of:</p>
                <ol className="list-decimal list-inside space-y-1">
                  <li>Your breach of this Agreement;</li>
                  <li>Your violation of any law or third-party rights;</li>
                  <li>Any use of the Application that is not expressly authorized by this Agreement.</li>
                </ol>

                <div className="text-2xl font-semibold mt-6 mb-2">I. Term &amp; Termination</div>
                <ol className="list-decimal list-inside space-y-1">
                  <li><strong>Term.</strong> This Agreement commences on your first use and continues until the end of the beta period or upon earlier termination.</li>
                  <li><strong>Termination.</strong> Either party may terminate this Agreement at any time with written notice. Upon termination, you must cease all use and destroy all copies of the Application.</li>
                </ol>

                <div className="text-2xl font-semibold mt-6 mb-2">J. Governing Law</div>
                <p>This Agreement is governed by the laws of the Commonwealth of Virginia, without regard to conflict-of-law rules. Any dispute shall be resolved in the state or federal courts located in Fairfax, Virginia.</p>

                <div className="text-2xl font-semibold mt-6 mb-2">K. Miscellaneous</div>
                <ul className="list-disc list-inside space-y-1">
                  <li><strong>Assignment.</strong> You may not assign this Agreement without MokshSoft’s prior written consent.</li>
                  <li><strong>Entire Agreement.</strong> This Agreement, together with any documents referenced herein, constitutes the entire understanding between the parties regarding the subject matter.</li>
                </ul>
              </div>                
                  
                
                
                
                
                <h2 className="text-xl font-bold mt-6 mb-2">User Agreement</h2>
                <p><strong>(additional acknowledgments required at each login)</strong></p>
                <p>
                    By checking the box labeled “I Agree” during sign-in, User confirms and agrees to the following statements in addition to the Terms & Conditions of Use:
                </p>

                <h2 className="text-xl font-bold mt-6 mb-2">Responsible Use</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I will use the Service solely for authorized, work-related EPR compliance research and will not disclose sensitive output to unauthorized parties.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">Confidentiality & Data Handling</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I understand that any documents I upload may contain proprietary or personal data; I have permission to share them and will anonymize or redact where required.
                    </li>
                    <li>
                    I will not store or export Company output to unsecured locations.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">No Reliance Without Verification</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I acknowledge that all answers are generated by AI, may contain inaccuracies, and do not constitute legal or regulatory advice.
                    </li>
                    <li>
                    Before relying on any output, I will validate the information against original statutes, agency guidance, or professional counsel.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">Citation & Attribution</h2>
                <ul className="list-disc ml-5">
                    <li>
                    When sharing excerpts externally (e.g., in reports), I will retain the accompanying citations provided by the Service to preserve context and source transparency.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">Compliance With Law & Policy</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I will comply with all applicable laws, regulations, and my employer’s internal policies when using the Service.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">Security Practices</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I will not share my login credentials or leave sessions unattended on an unlocked device.
                    </li>
                    <li>
                    I will promptly report any suspected security breach or unauthorized access.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">Feedback & Monitoring</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I consent to Company’s collection of anonymized usage metrics to monitor performance and improve features.
                    </li>
                    <li>
                    I may provide voluntary feedback; Company may use it without obligation or compensation.
                    </li>
                </ul>

                <h2 className="text-xl font-bold mt-6 mb-2">Acknowledgment of Updates</h2>
                <ul className="list-disc ml-5">
                    <li>
                    I understand this User Agreement may be updated periodically and that continued use constitutes acceptance of any revisions.
                    </li>
                </ul>
            </div>

        </div>
    )
}

export default UserAgreements